import React, { useRef, useState } from 'react'
import LoadingBar from 'react-top-loading-bar'
import TopBar from "../../sections/TopBar";
import Sidebar from "../../sections/Sidebar";

const Vendor = () => {
  const ref = useRef();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  return (
    <>
      <LoadingBar color="#084e8a" ref={ref} height={5} />
      <div
        className={`main_layout ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
      >
        <Sidebar isSidebarOpen={isSidebarOpen} />
        <div className="innerRight">
          <TopBar
            title="Vendors"
            menu=""
            toggleSidebar={toggleSidebar}
          />
          <div className="officersSec">

          </div>
        </div>
      </div>
    </>
  )
}

export default Vendor